import Avatar from '@savvy-kit/components/avatar';
import { cn } from '@savvy-kit/lib/utils';
import { isNil } from 'es-toolkit';

import type { AvatarCellContentProps } from '../../types/cell-types';

export function AvatarCellContent({
  imageUrl,
  firstName,
  lastName,
  value,
  description,
  size = 'default',
  className,
}: AvatarCellContentProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <Avatar imageUrl={imageUrl} firstName={firstName} lastName={lastName} size={size} />
      {(!isNil(value) || !isNil(description)) && (
        <div className="flex flex-col gap-0.5">
          {!isNil(value) && <span className="text-sm text-dark">{value}</span>}
          {!isNil(description) && <span className="text-xs text-secondary">{description}</span>}
        </div>
      )}
    </div>
  );
}
